




























import { Component, Emit, Mixins } from 'vue-property-decorator'

import ConfigField from '../../../ConfigField/ConfigField.vue'
import Tags from '../../../Tags/Tags.vue'
import FieldWrapper from '../../components/FieldWrapper.vue'
import { BaseInput } from '../../mixins'
import { FieldData, SelectOptionData } from '../../types'

@Component({
  components: {
    ConfigField,
    FieldWrapper,
    Tags,
  },
})
export default class RadioInput extends Mixins(BaseInput) {
  @Emit('change')
  change(event: Event): Event {
    return event
  }

  get radioInputSettings(): FieldData & { inline: boolean, options: Array<SelectOptionData> } {
    return this.settings as FieldData & { inline: boolean, options: Array<SelectOptionData> }
  }

  get options(): Array<SelectOptionData> {
    return this.radioInputSettings.options
  }

  get inline(): boolean {
    return this.radioInputSettings.inline ? this.radioInputSettings.inline : false
  }
}
